// Раздел карточки пользователя: заголовок со счётчиком и действием справа («Все» у «Журнала»,
// «Убрать из всех» у «Доступа к протоколам»). Общий для разделов карточки (UserCard.tsx)
// и раздела «Доступ к протоколам» (UserProtocolAccess.tsx, 023).
import { useId } from 'react';
import type { ReactNode, Ref } from 'react';

export function Section({
  title,
  count,
  action,
  headingRef,
  children,
}: {
  title: string;
  count?: number | undefined;
  action?: ReactNode;
  /**
   * Заголовок принимает фокус программно (tabIndex −1): на него возвращается фокус, когда кнопки,
   * открывшей окно, после действия уже нет («Убрать из всех» у опустевшего раздела).
   */
  headingRef?: Ref<HTMLHeadingElement>;
  children: ReactNode;
}) {
  const id = useId();
  return (
    <section className="kp-section" aria-labelledby={id}>
      <h3 ref={headingRef} className="t-sec-h" id={id} tabIndex={headingRef ? -1 : undefined}>
        {title}
        {count !== undefined ? <span className="t-cnt t-num">{count}</span> : null}
        {action ? <span className="kp-sec-action">{action}</span> : null}
      </h3>
      {children}
    </section>
  );
}
